import axios from "axios";
import { ILocation } from "../../types";
import qs from "qs";

export const getLocations = async (params: any): Promise<{
    locations: ILocation[]
}> => {
    const response = await axios.get('/booking/rule/locations', {
        params: { ...params, tenants: params.tenants?.join(',') || "", dealers: params.dealers?.join(',') || "" },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
    });
    return response.data;
};